module.exports = __webpack_public_path__ + "static/media/dos_and_donts_blog_img.b87c5cf4.webp";